import { useEffect, useState } from "react";
import MtbChambaForm from "../../components/chamba/MtbChambaForm";
import axios from "axios";
import MtbChambaFormClosed from "../../components/chamba/MtbChambaFormClosed";

export default function ChambaRacePage() {
  const [isChambaActive, setIsChambaActive] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchForms = async () => {
      try {
        const res = await axios.get(
           `${process.env.REACT_APP_API_BASE_URL}forms`
        );
        const forms = res.data;

        const chambaRace = forms.find(
          (item) => item.formName.toLowerCase() === "mtb chamba"
        );

        if (chambaRace && chambaRace.Active === "true") {
          setIsChambaActive(true);
        } else {
          setIsChambaActive(false);
        }
      } catch (error) {
        console.error("Error fetching forms:", error);
        setIsChambaActive(false);
      } finally {
        setLoading(false);
      }
    };

    fetchForms();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen text-gray-600">
        Loading Chamba data...
      </div>
    );
  }
  return (
    <div>{isChambaActive ? <MtbChambaForm /> : <MtbChambaFormClosed />};</div>
  );
}
